import React, { useEffect, useState } from 'react';
import './KeyStatisticsSimple.scss';

const KeyStatisticsSimple = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('key-statistics-simple-section');
      if (section) {
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Trigger animation when section is 50% visible
        if (rect.top < windowHeight * 0.5 && rect.bottom > 0) {
          setIsVisible(true);
        } else if (rect.bottom < -100 || rect.top > windowHeight + 100) {
          // Reset when section is completely out of view
          setIsVisible(false);
        }
      }
    };

    // Check on mount
    handleScroll();
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const statistics = [
    {
      id: 1,
      iconPath: "/images/key-statistics-simple/calender.svg",
      label: "Total Projects",
      value: "856",
      description: "Across 35 countries",
      trend: "+15% from previous year"
    },
    {
      id: 2,
      iconPath: "/images/key-statistics-simple/renewable-energy.svg",
      label: "Renewable Energy Projects",
      value: "412",
      description: "Solar, Wind & Hydro",
      trend: "+22% from previous year"
    },
    {
      id: 3,
      iconPath: "/images/key-statistics-simple/grid.svg",
      label: "Energy Access Projects",
      value: "170",
      description: "Off-grid Solutions",
      trend: "+12% from previous year"
    },
    {
      id: 4,
      iconPath: "/images/key-statistics-simple/people-outline.svg",
      label: "Population Served",
      value: "45M+",
      description: "Direct beneficiaries",
      trend: "+18% from previous year"
    }
  ];

  return (
    <section id="key-statistics-simple-section" className={`key-statistics-simple-section ${isVisible ? 'animate' : ''}`}>
      <div className="key-statistics-simple-container">
        <div className="key-statistics-simple-header">
          <h2 className="key-statistics-simple-title">Key Statistics</h2>
          <p className="key-statistics-simple-subtitle">
            A snapshot of energy access and renewable energy financing impact across Africa
          </p>
        </div>
        
        <div className="key-statistics-simple-grid">
          {statistics.map((stat) => (
            <div key={stat.id} className="key-statistics-simple-card">
              <div className="key-statistics-simple-icon-wrapper">
                <div className="key-statistics-simple-icon">
                  <img src={stat.iconPath} alt={stat.label} />
                </div>
              </div>
              
              <div className="key-statistics-simple-content">
                <h3 className="key-statistics-simple-label">{stat.label}</h3>
                <div className="key-statistics-simple-value">{stat.value}</div>
                <p className="key-statistics-simple-description">{stat.description}</p>
                <div className="key-statistics-simple-trend">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="17 6 23 6 23 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>{stat.trend}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyStatisticsSimple;
